
// resetSetItem("breadcrumb", JSON.stringify(this.navlist))
// 面包屑 数据存储方法 -- 后台
export function resetSetItem(key, newVal) {
    if (key === 'breadcrumb') {
        // 创建一个StorageEvent事件
        var newStorageEvent = document.createEvent('StorageEvent');
        const storage = {
            setItem: function (k, val) {
              sessionStorage.setItem(k, val);
              // 初始化创建的事件 自定义方法
              newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
              // 将方法 派发给window.dispatchEvent
              window.dispatchEvent(newStorageEvent)
            }
        }
        return storage.setItem(key, newVal);
    }
}

// 存储当前后台管理列表最外层父级Dom高度 用于计算 table 表格高度(滚动条)
export function UpdataDomHeight(key, newVal) {
    if (key === 'DomHeight') {
        // 创建一个StorageEvent事件 StorageEvent事件是Web Storage API内建的一套事件通知机制，当存储区域的内容发生改变（包括增加、修改、删除数据）时，会自动触发该事件，并把它发送给所有感兴趣的监听者
        var newStorageEvent = document.createEvent('StorageEvent');
        const storage = {
            setItem: function (k, val) {
              sessionStorage.setItem(k, val);
              // 初始化创建的事件 自定义方法
              newStorageEvent.initStorageEvent('UpdataDomHeight', false, false, k, null, val, null, null);
              // 将方法 派发给window.dispatchEvent (window下 使用addEventListener监听UpdataDomHeight)
              window.dispatchEvent(newStorageEvent)
            }
        }
        return storage.setItem(key, newVal);
    }
}